import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios'; // <-- 1. Ya no se importa axios
import api from './apiService'; // <-- 2. Importamos nuestro 'api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEraser } from '@fortawesome/free-solid-svg-icons';
import './UserManagement.css';

function UserManagement({ session }) { // session prop todavía se recibe, pero no la usamos para el token
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', password: '', salt: '', fullname: '', email: '', allow_dashboard: 0, allow_controlpanel: 0, allow_caller: 0, allow_useradmin: 0, allow_settings: 0, enabled: 1 });
  const [editUser, setEditUser] = useState(null);
  // const apiPort = ...; // <-- 3. Eliminado. 'apiService' maneja esto.

  const fetchUsers = useCallback(async () => { // <-- 4. Convertido a async/await
    try {
      // const apiDir = ...; // <-- 5. Eliminado
      // const response = await axios.get(apiDir, { headers: ... }); // <-- 6. Reemplazado
      const response = await api.get('/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  }, []); // <-- 7. Dependencias eliminadas. apiService maneja el token.

  const handleAddUser = async () => {
    try {
      // 8. ¡Llamada a la API simplificada!
      // apiService adjuntará automáticamente el token Y el X-Store-ID
      await api.post('/api/users', newUser);
      
      setNewUser({ username: '', password: '', salt: '', fullname: '', email: '', allow_dashboard: 0, allow_controlpanel: 0, allow_caller: 0, allow_useradmin: 0, allow_settings: 0, enabled: 1 });
      fetchUsers();
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };

  const handleEditUser = async () => {
    try {
      // 9. ¡Llamada a la API simplificada!
      await api.put(`/api/users/${editUser.id}`, editUser);
      setEditUser(null);
      fetchUsers();
    } catch (error) {
      console.error('Error editing user:', error);
    }
  };

  const handleDeleteUser = async (id) => {
    // 10. Reemplazado window.confirm por un confirm simple
    // (Idealmente, esto también debería ser un modal como en ControlPanel)
    if (window.confirm(`¿Está seguro que desea eliminar al usuario con ID ${id}?`)) {
        try {
          // 11. ¡Llamada a la API simplificada!
          await api.delete(`/api/users/${id}`);
          fetchUsers();
        } catch (error) {
          console.error('Error deleting user:', error);
        }
    }
  };

  const handleSetEditUser = (user) => { // <-- 12. Convertido a no-async
    setEditUser({ ...user, password: '', salt: '' });
  };


  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <div className="user-management-container">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Administración de Usuarios</h5>
                <p className="card-text">Aquí puede administrar los usuarios de la aplicación. Los nuevos usuarios se asignarán automáticamente a la tienda actual.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ paddingTop: "20px" }}>
          <div className="col-md-8 card">
            <div className="user-list">
              <h4 style={{ paddingTop: "10px" }}>Usuarios Registrados</h4>

              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Id</th>
                    <th>Usuario</th>
                    <th>Nombre Completo</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(user => (
                    <tr key={user.id}>
                      <td>
                        <button onClick={() => handleSetEditUser(user)} title="Editar">
                          <FontAwesomeIcon icon={faEdit} />
                        </button> &nbsp;
                        <button onClick={() => handleDeleteUser(user.id)} title="Eliminar">
                          <FontAwesomeIcon icon={faEraser} />
                        </button>
                      </td>
                      <td>{user.id}</td>
                      <td>{user.username}</td>
                      <td>{user.fullname}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col card" style={{ marginLeft: "15px" }}>
            <div className="user-form">
              <h4 style={{ paddingTop: "10px" }}>{editUser ? 'Modificar Usuario (Id = ' + editUser.id.toString() + ')' : 'Agregar Usuario'}</h4>
              <input
                type="text"
                placeholder="Usuario"
                value={editUser ? editUser.username : newUser.username}
                readOnly={editUser ? true : false} // No se puede cambiar el username al editar
                onChange={(e) => editUser ? setEditUser({ ...editUser, username: e.target.value }) : setNewUser({ ...newUser, username: e.target.value })}
                title="Nombre de usuario"
              />
              <input
                type="password"
                placeholder="Contraseña"
                value={editUser ? editUser.password : newUser.password}
                onChange={(e) => editUser ? setEditUser({ ...editUser, password: e.target.value }) : setNewUser({ ...newUser, password: e.target.value })}
                title={editUser ? "Dejar en blanco para no cambiar" : "Contraseña"}
              />
              <input
                type="text"
                placeholder="Nombre Completo"
                value={editUser ? editUser.fullname : newUser.fullname}
                onChange={(e) => editUser ? setEditUser({ ...editUser, fullname: e.target.value }) : setNewUser({ ...newUser, fullname: e.target.value })}
                title="Nombre completo"
              />
              <input
                type="email"
                placeholder="Email"
                value={editUser ? editUser.email : newUser.email}
                onChange={(e) => editUser ? setEditUser({ ...editUser, email: e.target.value }) : setNewUser({ ...newUser, email: e.target.value })}
                title="Correo electrónico"
              />

              <h5>Permisos</h5>

              <div className='container'>
                <div className='row'>
                  <div className='col'>
                    <label title="Permitir acceso al Dashboard" htmlFor="chkDashboard" className="chk-label">Dashboard</label>
                  </div>
                  <div className='col'>
                    <input
                      id="chkDashboard"
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.allow_dashboard : newUser.allow_dashboard}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, allow_dashboard: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, allow_dashboard: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <label title="Permitir acceso a la Botonera" htmlFor="chkControlPanel" className="chk-label">Botonera</label>
                  </div>
                  <div className='col'>
                    <input
                      id="chkControlPanel"
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.allow_controlpanel : newUser.allow_controlpanel}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, allow_controlpanel: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, allow_controlpanel: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <label title="Permitir acceso al Llamador" htmlFor="chkCaller" className="chk-label" >Llamador</label>
                  </div>
                  <div className='col'>
                    <input
                      id='chkCaller'
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.allow_caller : newUser.allow_caller}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, allow_caller: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, allow_caller: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <label title="Permitir acceso a la Administración de Usuarios" htmlFor="chkUserAdmin" className='chk-label' >ABM de Usuarios</label>
                  </div>
                  <div className='col'>
                    <input
                      id='chkUserAdmin'
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.allow_useradmin : newUser.allow_useradmin}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, allow_useradmin: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, allow_useradmin: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <label title="Permitir acceso a la Configuración" htmlFor="chkSettings" className='chk-label'>Settings</label>
                  </div>
                  <div className='col'>
                    <input
                      id='chkSettings'
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.allow_settings : newUser.allow_settings}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, allow_settings: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, allow_settings: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <label title="Usuario habilitado" htmlFor="chkEnabled" className='chk-label' >Habilitido</label>
                  </div>
                  <div className='col'>
                    <input
                      id='chkEnabled'
                      type="checkbox"
                      className='chk-input'
                      checked={editUser ? editUser.enabled : newUser.enabled}
                      onChange={(e) => editUser ? setEditUser({ ...editUser, enabled: e.target.checked ? 1 : 0 }) : setNewUser({ ...newUser, enabled: e.target.checked ? 1 : 0 })}
                    />
                  </div>
                </div>
              </div>
              <button onClick={editUser ? handleEditUser : handleAddUser}>
                {editUser ? 'Guardar Cambios' : 'Agregar Usuario'}
              </button>
              {editUser && <button onClick={() => setEditUser(null)}>Cancelar</button>}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default UserManagement;
